import { render, staticRenderFns } from "./advertorial.vue?vue&type=template&id=2ce18ee9&"
import script from "./advertorial.vue?vue&type=script&lang=js&"
export * from "./advertorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports